  document.addEventListener('DOMContentLoaded', function() {
  // Listen for click event on Add to Cart buttons
  const cartNotification = document.getElementById('cart-notification');
    
  // Attach the event listener to a parent element that exists from the beginning
  document.addEventListener('click', function(e) {
    // Check if the clicked element is an add-to-cart button
    if (e.target && e.target.classList.contains('add-to-cart-btn')) {
      
        e.preventDefault();
        
        // Get product and variant IDs from data attributes
        const productId = e.target.getAttribute('data-product-id');
        const variantId = e.target.getAttribute('data-product-variant-id');
        
        // AJAX request to add product to cart
        fetch(`https://dygma.com/cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          // Handle success or error (you can redirect to the cart page, update mini-cart, etc.)
          console.log('Product added to cart', data);
          populateCartNotification(data);
          cartNotification.classList.add('animate');
          cartNotification.classList.add('active');
  
          // Update the cart number display
          updateCartNumber();
        })
        .catch((error) => {
          console.error('Error adding to cart', error);
        });
      
     }
  });

  // Function to populate Cart Notification with product details
  function populateCartNotification(productData) {
    const cartNotificationProduct = document.getElementById('cart-notification-product');
    console.log("data: ", productData);
    // Create HTML content for product details
    const productHTML = `
      <img class="cart-notification-product__image" src="${productData.featured_image.url}" alt="${productData.title}" width="70" height="43" loading="lazy">
      <div class="cart-notification-product__info">
      <h3 class="cart-notification-product__name h4">${productData.title}</h3>
      </div>
    `;
    // console.log(cartNotificationProduct);
    // Set HTML content to cart notification product div
    cartNotificationProduct.innerHTML = productHTML;
  }
  

    
  // Function to update the cart number display
  function updateCartNumber() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      // Get the cart quantity from the cart data
      const cartQuantity = data.item_count || 0;
      
      // Update the cart number display on the frontend
      var cartQuantityActual = document.querySelector('.cart-count-bubble [aria-hidden]');
      if (cartQuantityActual) {
        cartQuantityActual.textContent = cartQuantity.toString();
      }
       
    })
    .catch(error => {
      console.error('Error fetching cart data', error);
    });
  }
  
  // Initial call to update the cart number on page load
  updateCartNumber();
});